import React, { useState, useEffect, useRef } from "react";
import { IonModal, IonIcon, IonAvatar } from "@ionic/react";
import {
  callOutline,
  micCircle,
  micOffCircle,
} from "ionicons/icons";
import "./IncomingCallUser.scss";
import { utilService } from "../../../../../services";
import moment from "moment";
import { CallService } from "../../Call.service";
import { useTranslation } from "react-i18next";


interface callUserParams {
  doctorInfoData: any;
  userAgent: any;
  showIncomingCallUserModal: boolean;
  enableIncomingScreen: boolean;
  session?: any;
  onCancel: () => void;
  onOk: () => void;
  onAnswer?: () => void;
  onHangup?: () => void;
}

const IncomingCallUser: React.FC<callUserParams> = (props) => {
    const { t } = useTranslation("call");
  
  const [isMicOff, setIsMicOff] = useState(false);
  const [isCallAccepted, setIsCallAccepted] = useState(false);
  const ringtoneRef = useRef<HTMLAudioElement | null>(null);
  // [FIX 1] Create a reference for the HTML Audio element
  const audioRef = useRef<HTMLAudioElement>(null);
// const getUserID = ?.getHeader('X-User-Id')
  const checkIfModalShow = () => {
    if (isCallAccepted) {
      return true;
    } else {
      return props.showIncomingCallUserModal || props.enableIncomingScreen;
    }
  };

  // --- [FIX 2] Handle Incoming Audio Stream ---
  useEffect(() => {
    const session = props.session;
    if (!session) return;

    // Helper to attach stream to audio element
    const handleRemoteStream = (stream: MediaStream) => {
      if (audioRef.current) {
        console.log("Attaching remote stream to audio element");
        audioRef.current.srcObject = stream;
        // Attempt to play immediately
        audioRef.current.play().catch(e => console.warn("Autoplay blocked (waiting for interaction):", e));
      }
    };

//     useEffect(() => {
//   const unlock = () => {
//     const audio = new Audio();
//     audio.play().catch(() => {});
//     window.removeEventListener("click", unlock);
//   };
//   window.addEventListener("click", unlock);
// }, []);

    // 1. Listen for the peerconnection to get the remote track
    const handlePeerConnection = (data: any) => {
       const peerconnection = data.peerconnection;
       
       peerconnection.addEventListener('track', (event: any) => {
         console.log("Remote track received:", event.streams[0]);
         if (event.streams && event.streams[0]) {
            handleRemoteStream(event.streams[0]);
         }
       });
    };

    session.on('peerconnection', handlePeerConnection);

    // 2. Fallback: If connection already exists (rare race condition)
    if (session.connection) {
       session.connection.getReceivers().forEach((receiver: any) => {
         if (receiver.track && receiver.track.kind === 'audio') {
            const stream = new MediaStream([receiver.track]);
            handleRemoteStream(stream);
         }
       });
    }

    // --- Standard Event Listeners ---
    const handleEnded = () => closeModal();
    const handleFailed = (e: any) => {
      console.log("Call failed:", e);
      if (e.originator === 'remote' && e.cause === 'Canceled') {
          initiateMissedCallStatus();
      }
      props.onOk();
      closeModal();
    };

    session.on('ended', handleEnded);
    session.on('failed', handleFailed);

    return () => {
      session.removeListener('peerconnection', handlePeerConnection);
      session.removeListener('ended', handleEnded);
      session.removeListener('failed', handleFailed);
    };
  }, [props.session]);

  // --- Call Actions ---

const acceptCall = () => {
  // Stop ringtone immediately
  if (ringtoneRef.current) {
    ringtoneRef.current.pause();
    ringtoneRef.current.currentTime = 0;
  }

  if (props.session) {
    // 1. Answer via JsSIP
    if (props.onAnswer) {
      props.onAnswer();
    } else {
      props.session.answer({
        mediaConstraints: { audio: true, video: false }
      });
    }

    // 2. Force remote audio to play (browser policy fix)
    if (audioRef.current) {
      audioRef.current.play()
        .then(() => console.log("Audio playing successfully"))
        .catch((e) => console.error("Audio play failed:", e));
    }

    setIsCallAccepted(true);
  }
};
  const closeModal = () => {
    setIsCallAccepted(false);
    setIsMicOff(false);
    // Reset audio source
    if (audioRef.current) {
      audioRef.current.srcObject = null;
    }
    props.onOk();
  };
const hangUp = (): void => {
  // Stop ringtone immediately
  if (ringtoneRef.current) {
    ringtoneRef.current.pause();
    ringtoneRef.current.currentTime = 0;
  }

  if (props.session) {
    if (props.onHangup) {
      props.onHangup();
    } else {
      props.session.terminate();
    }
  }

  closeModal();
};
  const mute = () => {
    if (props.session) {
      if (isMicOff) {
        props.session.unmute({ audio: true });
        setIsMicOff(false);
      } else {
        props.session.mute({ audio: true });
        setIsMicOff(true);
      }
    }
  };

  async function initiateMissedCallStatus() {
    let fromUserGuid = props.doctorInfoData?.guid;
    if(!fromUserGuid && props.session) {
       fromUserGuid = props.session.remote_identity.uri.user;
    }

    const date = moment(new Date());
    const dateTime = date.format("MM-DD-YYYY HH:mm");
    const params = {
      reg_code: utilService.getNetwork(),
      "from-user": fromUserGuid,
      "to-user": utilService.getLoggedUserGuid(),
      time: dateTime,
      about: "",
    };

    if (fromUserGuid) {
        const respMissedCallStatus: any = await CallService.missedCallStatusUpdate(
          params
        );
        if (!respMissedCallStatus.isSuccess) {
           console.log("Error updating missed call status");
        }
    }
  }

  useEffect(() => {
  if (!props.session) return;

  const session = props.session;

  session.on("peerconnection", (e: any) => {
    const pc = e.peerconnection;

    pc.ontrack = (event: any) => {
      console.log("Remote track received", event.streams);

      if (audioRef.current && event.streams[0]) {
        audioRef.current.srcObject = event.streams[0];
        audioRef.current.muted = false;
        audioRef.current.volume = 1;

        audioRef.current.play()
          .then(() => console.log("Audio playing"))
          .catch(err => console.error("Audio blocked:", err));
      }
    };
  });

}, [props.session]);

useEffect(() => {
  if (props.showIncomingCallUserModal && !isCallAccepted) {
    ringtoneRef.current?.play().catch(err => {
      console.warn("Ringtone autoplay blocked until user interacts", err);
    });
  } else {
    ringtoneRef.current?.pause();
    if (ringtoneRef.current) ringtoneRef.current.currentTime = 0;
  }
}, [props.showIncomingCallUserModal, isCallAccepted]);

  return (
    <div>
      {/* [FIX 4] Hidden Audio Element to play the remote sound */}
      <audio ref={audioRef} autoPlay style={{ display: 'none' }} playsInline />
<audio
  ref={ringtoneRef}
  src="/assets/audio/bell.mp3"
  loop
  preload="auto"
/>
      <IonModal
        isOpen={checkIfModalShow()}
        backdropDismiss={false}
        className="incoming-call-user-modal"
      >
        <div className="call-user-modal-wrapper">
          <div className="Profile-pic-div">
            <IonAvatar>
              <img
                src={props.doctorInfoData.image}
                alt="Profile"
                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                  const target = e.target as HTMLImageElement;
                  target.src = 'assets/images/defaultProfilePic.png';
                }}
              />
            </IonAvatar>
          </div>
          <div className="doctor-name-label">
            <span>
              {props.doctorInfoData.firstName} {props.doctorInfoData.lastName}
            </span>
          </div>
          <div className="group-details">
            {props.doctorInfoData.groups?.toString()}
          </div>
          <div className="calling-gif-div">
            <img
              src="assets/images/calling-gif.svg"
              alt="Calling..."
              className="calling-gif"
            />
          </div>
          <div className="calling-label">
             {isCallAccepted ? t("inCall") : t("incomingCall")}
          </div>
          
          <div className="call-function-buttons">
            {/* Mute Button */}
            {!isMicOff && isCallAccepted && (
              <div className="mic-icon" title={t("mute")} onClick={() => mute()}>
                <IonIcon slot="start" icon={micCircle} />
              </div>
            )}
            {isMicOff && isCallAccepted && (
              <div
                className="mic-mute-icon"
                title={t("unmute")}
                onClick={() => mute()}
              >
                <IonIcon slot="start" icon={micOffCircle} />
              </div>
            )}

            {/* End Call Button */}
            <div
              className="end-call-icon"
              title={isCallAccepted ? t("endCall") : t("rejectCall")}
              onClick={() => hangUp()}
            >
              <IonIcon slot="start" icon={callOutline} />
            </div>

            {/* Answer Call Button */}
            {!isCallAccepted && (
              <div
                className="accept-call-icon"
                title={t("acceptCall")}
                onClick={() => acceptCall()}
              >
                <IonIcon slot="start" icon={callOutline} />
              </div>
            )}
          </div>
          <div className="footer-message-div w-100 text-center">
          </div>
        </div>
      </IonModal>
    </div>
  );
};

export default IncomingCallUser;